import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import { Const } from '../const';

import { environment } from '../../environments/environment';

import { SystemDashboardApiParameter } from '../servicer/models/system-dashboard-api-parameter';
import { SystemDashboard } from '../servicer/models/system-dashboard';

import { SystemDashboardServiceProvider } from '../servicer/system-dashboard-service';

/**
 * ダッシュボードを定期間隔で取得するプロバイダー.
 */
@Injectable()
export class SystemDashboardIntervalReceiverProvider {
  /** ダッシュボードの空のレスポンス. */
  private readonly dashboardEmptyResponse = null;

  /** ダッシュボード情報. */
  public dashboardInfos$: BehaviorSubject<SystemDashboard> = new BehaviorSubject<SystemDashboard>(this.dashboardEmptyResponse);

  /** インターバルのSubscription. */
  private intervalSubscription: Subscription = null;

  /** パラメータ. */
  private parameter: SystemDashboardApiParameter = { userIds: null } as SystemDashboardApiParameter;

  /** 実行中. */
  private processing = false;

  constructor(
    public systemDashboardService: SystemDashboardServiceProvider
  ) { }

  /**
   * 開始.
   */
  start() {
    // 初回のダッシュボード取得
    this.get().subscribe(() => {
      this.intervalSubscription = Observable.interval(environment.systemDashboardInterval)
        .subscribe(() => this.execute());
    });
  }

  /**
   * 実行します.
   */
  execute() {
    of(this.processing)
      .filter((processing) => !processing)
      .pipe(tap(() => this.processing = true))
      .flatMap(() => this.get())
      .pipe(tap(() => this.processing = false))
      .subscribe();
  }

  /**
   * 停止.
   */
  stop() {
    this.dashboardInfos$.next(this.dashboardEmptyResponse);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  /**
   * ユーザIDのリストを設定します.
   *
   * @param userIds ユーザIDのリスト
   */
  setUserIds(userIds: number[]) {
    this.parameter.userIds = userIds;
  }

  /**
   * ダッシュボード表示情報を取得します.
   * 定期的に呼び出されるため、エラーが発生しても、何も処理をしません.
   */
  private get(): Observable<SystemDashboard> {
    return this.systemDashboardService.get(this.parameter)
      .map((response) => {
        if (response.result === Const.ResponseResult.SUCCESS) {
          this.dashboardInfos$.next(response.item);
        }

        return this.dashboardInfos$.value;
      })
      .catch((error) => {
        console.error(error);
        return Observable.of(this.dashboardInfos$.value);
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/system-dashboard-interval-receiver/system-dashboard-interval-receiver.ts